(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-header"]) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.cp-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})}});document.addEventListener('click',event=>{const menu=event.target.closest('.cp-mobile-menu');if(menu&&event.target.closest('a'))menu.open=false;document.querySelectorAll('.cp-mobile-menu[open]').forEach(openMenu=>{if(!openMenu.contains(event.target))openMenu.open=false})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-home-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fh-product-tabs'))customElements.define('fh-product-tabs',class extends HTMLElement{connectedCallback(){if(this.fhReady)return;this.fhReady=true;const tabs=[...this.querySelectorAll('[data-fh-tab]')];const choose=t=>{tabs.forEach(b=>{const on=b===t;b.setAttribute('aria-selected',on);b.tabIndex=on?0:-1});this.querySelectorAll('[data-fh-panel]').forEach(p=>p.hidden=p.dataset.fhPanel!==t.dataset.fhTab)};tabs.forEach((t,i)=>{t.addEventListener('click',()=>choose(t));t.addEventListener('keydown',e=>{let j;if(e.key==='ArrowRight')j=(i+1)%tabs.length;if(e.key==='ArrowLeft')j=(i-1+tabs.length)%tabs.length;if(e.key==='Home')j=0;if(e.key==='End')j=tabs.length-1;if(j!==undefined){e.preventDefault();choose(tabs[j]);tabs[j].focus()}})})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-home-videos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fassoda-video-reel'))customElements.define('fassoda-video-reel',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('.fv-videos__track');this.originals=[...this.querySelectorAll('[data-reel-card]')];this.count=this.originals.length;if(!this.count)return;this.reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;this.visible=false;this.userPaused=false;this.cleanups=[];
if(this.count>1){const cloneSet=()=>this.originals.map(c=>{const copy=c.cloneNode(true);copy.removeAttribute('data-shopify-editor-block');copy.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));copy.dataset.reelClone='true';return copy});this.track.prepend(...cloneSet());this.track.append(...cloneSet())}
this.cards=[...this.querySelectorAll('[data-reel-card]')];this.active=this.count>1?this.count+Math.floor(this.count/2):0;
this.onScroll=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());clearTimeout(this.settle);this.settle=setTimeout(()=>this.normalize(),180)};this.track.addEventListener('scroll',this.onScroll,{passive:true});
this.cards.forEach((card,i)=>{const video=card.querySelector('video'),button=card.querySelector('.fv-videos__play'),sound=card.querySelector('.fv-videos__sound');video.muted=true;video.loop=true;button.addEventListener('click',()=>{if(i!==this.active){this.userPaused=false;this.move(i)}else{this.userPaused=!video.paused;if(this.userPaused)video.pause();else this.play(video)}});video.addEventListener('playing',()=>card.classList.add('is-playing'));video.addEventListener('pause',()=>card.classList.remove('is-playing'));sound.addEventListener('click',()=>{video.muted=!video.muted;sound.setAttribute('aria-pressed',String(!video.muted));sound.setAttribute('aria-label',video.muted?'Activer le son':'Couper le son')})});
this.onKey=e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.userPaused=false;this.move(this.active+(e.key==='ArrowRight'?1:-1))}};this.track.addEventListener('keydown',this.onKey);
this.onVisibility=()=>{if(document.hidden)this.pauseAll();else this.update()};document.addEventListener('visibilitychange',this.onVisibility);
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible)this.update();else this.pauseAll()},{threshold:.25});this.observer.observe(this);
this.resize=new ResizeObserver(()=>this.move(this.active,false));this.resize.observe(this.track);
this.startFrame=requestAnimationFrame(()=>{this.move(this.active,false);this.update()});
this.timer=setInterval(()=>{if(this.dataset.auto==='true'&&!this.reduced&&this.visible&&!document.hidden&&!this.userPaused&&!this.matches(':hover')&&!this.contains(document.activeElement)){this.move(this.active+1)}},Number(this.dataset.interval)||8000);
this.selectBlock=e=>{const card=e.target.closest('[data-reel-card]');if(card){const i=this.cards.indexOf(card);if(i>=0)this.move(i)}};this.addEventListener('shopify:block:select',this.selectBlock);
}
center(i){const c=this.cards[i];return c.offsetLeft-(this.track.clientWidth-c.offsetWidth)/2}
move(i,smooth=true){i=Math.max(0,Math.min(i,this.cards.length-1));this.track.scrollTo({left:this.center(i),behavior:smooth&&!this.reduced?'smooth':'instant'});if(!smooth){this.active=i;this.update()}}
update(){const mid=this.track.scrollLeft+this.track.clientWidth/2;let nearest=0,d=Infinity;this.cards.forEach((c,i)=>{const distance=Math.abs(c.offsetLeft+c.offsetWidth/2-mid);if(distance<d){d=distance;nearest=i}});const changed=nearest!==this.active;this.active=nearest;if(changed)this.userPaused=false;this.cards.forEach((c,i)=>{c.classList.toggle('is-active',i===nearest);c.classList.toggle('is-near',Math.abs(i-nearest)===1);const v=c.querySelector('video');if(i===nearest&&this.visible&&!document.hidden&&!this.userPaused&&!this.reduced)this.play(v);else if(i!==nearest)v.pause()})}
play(video){if(video.paused){const p=video.play();if(p)p.catch(()=>{})}}
pauseAll(){this.cards.forEach(c=>c.querySelector('video').pause())}
normalize(){if(this.count<2)return;let i=this.active;if(i<this.count)i+=this.count;else if(i>=this.count*2)i-=this.count;if(i!==this.active){const previous=this.cards[this.active].querySelector('video'),next=this.cards[i].querySelector('video');try{if(Number.isFinite(previous.currentTime))next.currentTime=previous.currentTime}catch(e){}this.move(i,false)}}
disconnectedCallback(){clearInterval(this.timer);clearTimeout(this.settle);cancelAnimationFrame(this.frame);cancelAnimationFrame(this.startFrame);this.observer?.disconnect();this.resize?.disconnect();this.track?.removeEventListener('scroll',this.onScroll);this.track?.removeEventListener('keydown',this.onKey);document.removeEventListener('visibilitychange',this.onVisibility);this.removeEventListener('shopify:block:select',this.selectBlock);this.pauseAll()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-teck-compare"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('teck-compare'))customElements.define('teck-compare',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const select=this.querySelector('select'),columns=[...this.querySelectorAll('[data-column]')],media=matchMedia('(max-width:749px)');
const update=()=>columns.forEach(column=>column.style.display=media.matches&&column.dataset.column!==select.value?'none':column.tagName==='COL'?'table-column':'table-cell');
select.addEventListener('change',update);media.addEventListener('change',update);update();
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-teck-reasons"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('teck-reasons'))customElements.define('teck-reasons',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const track=this.querySelector('.teck-reasons__track'),originals=[...track.children],dots=[...this.querySelectorAll('[data-loop-index]')],n=originals.length;
if(n<2)return;
this.abort=new AbortController();const signal=this.abort.signal;
const clone=card=>{const c=card.cloneNode(true);c.setAttribute('aria-hidden','true');c.inert=true;c.removeAttribute('data-shopify-editor-block');c.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));c.querySelectorAll('[data-shopify-editor-block]').forEach(e=>e.removeAttribute('data-shopify-editor-block'));c.querySelectorAll('video').forEach(v=>{v.removeAttribute('autoplay');v.preload='none'});return c};
track.prepend(...originals.map(clone));track.append(...originals.map(clone));
const cards=[...track.children];let current=0,touching=false,jumping=false,timer;
const position=i=>cards[i].offsetLeft-cards[0].offsetLeft;
const nearest=()=>{let index=n,distance=Infinity;cards.forEach((c,i)=>{const d=Math.abs(position(i)-track.scrollLeft);if(d<distance){index=i;distance=d}});return index};
const sync=i=>{current=((i-n)%n+n)%n;dots.forEach((d,k)=>{if(k===current)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')})};
const jump=i=>{jumping=true;track.style.scrollSnapType='none';track.scrollTo({left:position(i),behavior:'instant'});sync(i);requestAnimationFrame(()=>requestAnimationFrame(()=>{track.style.scrollSnapType='';jumping=false}))};
const settle=()=>{if(touching||jumping)return;const i=nearest();sync(i);if(i<n)jump(i+n);else if(i>=2*n)jump(i-n)};
const go=i=>{let delta=i-current;if(delta>n/2)delta-=n;if(delta<-n/2)delta+=n;track.scrollTo({left:position(nearest()+delta),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})};
dots.forEach((d,i)=>d.addEventListener('click',()=>go(i),{signal}));
track.addEventListener('scroll',()=>{if(jumping)return;sync(nearest());clearTimeout(timer);timer=setTimeout(settle,180)},{passive:true,signal});
track.addEventListener('scrollend',settle,{signal});
track.addEventListener('touchstart',()=>{touching=true},{passive:true,signal});track.addEventListener('touchend',()=>{touching=false;clearTimeout(timer);timer=setTimeout(settle,180)},{passive:true,signal});
track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go((current+(e.key==='ArrowRight'?1:-1)+n)%n)}},{signal});
let width=0;this.observer=new ResizeObserver(()=>{if(Math.abs(width-track.clientWidth)>1){width=track.clientWidth;jump(n+current)}});this.observer.observe(track);jump(n);
this.cleanup=()=>{clearTimeout(timer);this.abort.abort();this.observer.disconnect()};
this.addEventListener('play',e=>{if(e.target.tagName==='VIDEO')this.querySelectorAll('video').forEach(v=>{if(v!==e.target)v.pause()})},{capture:true,signal});
}
disconnectedCallback(){if(this.cleanup)this.cleanup()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-teck-stories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('teck-stories'))customElements.define('teck-stories',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const track=this.querySelector('.teck-stories__track'),originals=[...track.children],dots=[...this.querySelectorAll('[data-loop-index]')],n=originals.length;
if(n<2)return;
this.abort=new AbortController();const signal=this.abort.signal;
const clone=card=>{const c=card.cloneNode(true);c.setAttribute('aria-hidden','true');c.inert=true;c.removeAttribute('data-shopify-editor-block');c.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));c.querySelectorAll('[data-shopify-editor-block]').forEach(e=>e.removeAttribute('data-shopify-editor-block'));c.querySelectorAll('video').forEach(v=>{v.removeAttribute('autoplay');v.preload='none'});return c};
track.prepend(...originals.map(clone));track.append(...originals.map(clone));
const cards=[...track.children];let current=0,touching=false,jumping=false,timer;
const position=i=>cards[i].offsetLeft-cards[0].offsetLeft;
const nearest=()=>{let index=n,distance=Infinity;cards.forEach((c,i)=>{const d=Math.abs(position(i)-track.scrollLeft);if(d<distance){index=i;distance=d}});return index};
const sync=i=>{current=((i-n)%n+n)%n;dots.forEach((d,k)=>{if(k===current)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')})};
const jump=i=>{jumping=true;track.style.scrollSnapType='none';track.scrollTo({left:position(i),behavior:'instant'});sync(i);requestAnimationFrame(()=>requestAnimationFrame(()=>{track.style.scrollSnapType='';jumping=false}))};
const settle=()=>{if(touching||jumping)return;const i=nearest();sync(i);if(i<n)jump(i+n);else if(i>=2*n)jump(i-n)};
const go=i=>{let delta=i-current;if(delta>n/2)delta-=n;if(delta<-n/2)delta+=n;track.scrollTo({left:position(nearest()+delta),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})};
dots.forEach((d,i)=>d.addEventListener('click',()=>go(i),{signal}));
track.addEventListener('scroll',()=>{if(jumping)return;sync(nearest());clearTimeout(timer);timer=setTimeout(settle,180)},{passive:true,signal});
track.addEventListener('scrollend',settle,{signal});
track.addEventListener('touchstart',()=>{touching=true},{passive:true,signal});track.addEventListener('touchend',()=>{touching=false;clearTimeout(timer);timer=setTimeout(settle,180)},{passive:true,signal});
track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go((current+(e.key==='ArrowRight'?1:-1)+n)%n)}},{signal});
let width=0;this.observer=new ResizeObserver(()=>{if(Math.abs(width-track.clientWidth)>1){width=track.clientWidth;jump(n+current)}});this.observer.observe(track);jump(n);
this.cleanup=()=>{clearTimeout(timer);this.abort.abort();this.observer.disconnect()};
this.addEventListener('play',e=>{if(e.target.tagName==='VIDEO')this.querySelectorAll('video').forEach(v=>{if(v!==e.target)v.pause()})},{capture:true,signal});
}
disconnectedCallback(){if(this.cleanup)this.cleanup()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-teck-utensils"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('teck-utensils'))customElements.define('teck-utensils',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[role=tabpanel]')];
const activate=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1});panels.forEach((panel,i)=>panel.hidden=i!==index);if(focus)tabs[index].focus()};
tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(index));tab.addEventListener('keydown',e=>{let next=index;if(e.key==='ArrowDown'||e.key==='ArrowRight')next=(index+1)%tabs.length;else if(e.key==='ArrowUp'||e.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();activate(next,true)})});
this.addEventListener('shopify:block:select',e=>{const index=panels.findIndex(panel=>panel.contains(e.target)||panel===e.target);if(index>=0)activate(index)});
}
});

  } catch(e) { console.error(e); }
})();
})();
